/** @format */

import React, { Component } from "react";
import {
	Container,
	Row,
	Col,
	Breadcrumb,
	BreadcrumbItem,
	Button,
	Alert,
} from "reactstrap";
import Icon from "../components/Icon";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { showNotification } from "../global/notification";
import jquery from "jquery";
import Loader from "../components/Loader";
import {
	setCookie,
	getCookie,
	eraseCookie,
	setLocalStorage,
	getLocalStorage,
	getUrlParam,
} from "../global/browserFunctions";

class Confirmation extends Component {
	constructor(props) {
		super(props);
		var today = new Date();
		var dd = String(today.getDate()).padStart(2, "0");
		var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
		var yyyy = today.getFullYear();
		var location = getCookie("country");
		var hasMessage=false, message="";
		
		//console.log(props)
		var data = location == "US" ? window.HOME_US : window.HOME_CANADA;
		if(data['Order Confirmation Message'].value)
		{
			hasMessage=true;
			message = data['Order Confirmation Message'].value;
		}
		this.state = {
			loading: false,
			name: getCookie("name"),
			id: "",
            date: mm + '/' + dd + '/' + yyyy,
            total: getUrlParam("amt") || 'NA',
			message: message,
			hasMessage: hasMessage
		};
		document.title = "Checkout Confirmation";
		var id = getUrlParam("id") || false;
		this.state.id = id;
		if (!id) {
			this.GoToPage("/");
		}
		if (!getCookie("log")) {
			this.GoToPage("/");
		}

		
	}

	GoToPage(path) {
		this.props.history.push(path);
	}

	render() {
		return (
			<React.Fragment>
                <Header headermenu={this.headermenu} history={this.props.history} />
				<section className='hero py-6'>
					<Container>
						<Breadcrumb className='pl-0'>
							<BreadcrumbItem>
								<a href='/home'>Home</a>
							</BreadcrumbItem>
							<BreadcrumbItem active>Order confirmed</BreadcrumbItem>
						</Breadcrumb>
						<div className='hero-content'>
							<h1 className='hero-heading'>Order confirmed</h1>
							<Alert color='success' className='d-flex align-items-center'>
								<Icon
									icon='checked-circle-1'
									className='w-3rem h-3rem svg-icon-light flex-shrink-0 mr-3'
								/>
								Your order is confirmed
							</Alert>
						</div>
					</Container>
				</section>
				<section className='pb-6'>
					<Container>
						<p className='lead'>
							Thank you, {this.state.name}.
						</p>
						{this.state.hasMessage &&
						<p className='lead mb-5'>
						Your order is confirmed. Your order hasn't shipped yet but we will send you an email when
						it does.
						</p>
						}
						{!this.state.hasMessage &&
						<p className='lead mb-5' dangerouslySetInnerHTML={{ __html: this.state.message }} ></p>
						}
						<p className='mb-6'>
							<a href='/orders'>
								<Button color='outline-dark'>View or manage your order</Button>
							</a>
						</p>
						<div className='p-5 bg-gray-100'>
							<Row>
								<Col xs='6' lg='3' className='mb-5 mb-lg-0'>
									<div className='text-sm text-uppercase text-muted mb-3'>
										Order no.
									</div>
									<span className='h5'>{this.state.id}</span>
								</Col>
								<Col xs='6' lg='3' className='mb-5 mb-lg-0'>
									<div className='text-sm text-uppercase text-muted mb-3'>
										Date
									</div>
									<span className='h5'>{this.state.date}</span>
								</Col>
								<Col xs='6' lg='3' className='mb-5 mb-lg-0'>
									<div className='text-sm text-uppercase text-muted mb-3'>
										Total
									</div>
									<span className='h5'>${this.state.total}</span>
								</Col>
							</Row>
						</div>
					</Container>
				</section>
                <Footer />
			</React.Fragment>
		);
	}
}

export default Confirmation;
